// menuIcons.tsx — يربط مفتاح عنصر القائمة (icon_key/permission_key/text_key) بأيقونة Tabler.
import {
	IconHome2,
	IconChartBar,
	IconHorse,
	IconTrophy,
	IconBed,
	IconStethoscope,
	IconHorseshoe,
	IconEgg,
	IconTruck,
	IconCalculator,
	IconClipboardCheck,
	IconSettings,
	IconShieldLock,
	IconUsers,
	IconUserCircle,
	IconBuildingWarehouse,
	IconDoorEnter,
	IconPill,
	IconTools,
	IconMicroscope,
	IconFlask,
	IconFileCertificate,
	IconCash,
	IconReportMoney,
	IconDatabaseExport,
	IconTag,
	IconListDetails,
	IconLayoutDashboard,
	IconBuildingBank,
	IconIdBadge2,
	IconApps,
	type Icon as TablerIcon,
} from '@tabler/icons-react';
// مجموعة أيقونات عامّة إضافيّة — لا تخصّ صفحة بعينها، غرضها توسيع خيارات منتقي الأيقونة
// (IconPicker) ليختار المدير أيّ أيقونة مناسبة لرابط قائمة مخصَّص بدل الاقتصار على المفاتيح
// الدلاليّة أعلاه.
import {
	IconActivity,
	IconAlarm,
	IconAmbulance,
	IconArchive,
	IconArrowDown,
	IconArrowLeft,
	IconArrowRight,
	IconArrowUp,
	IconArrowsExchange,
	IconAward,
	IconBandage,
	IconBarcode,
	IconBath,
	IconBattery,
	IconBedFlat,
	IconBell,
	IconBellRinging,
	IconBike,
	IconBook,
	IconBookmark,
	IconBox,
	IconBrain,
	IconBriefcase,
	IconBuilding,
	IconBulb,
	IconBus,
	IconCalendar,
	IconCalendarCheck,
	IconCalendarClock,
	IconCalendarEvent,
	IconCamera,
	IconCar,
	IconCarCrash,
	IconChartLine,
	IconChartPie,
	IconCheck,
	IconCheckbox,
	IconCircleCheck,
	IconCircleX,
	IconClipboard,
	IconClipboardList,
	IconClock,
	IconCloud,
	IconCoin,
	IconCreditCard,
	IconCrown,
	IconDatabase,
	IconDeer,
	IconDeviceFloppy,
	IconDiamond,
	IconDog,
	IconDoorExit,
	IconDownload,
	IconDroplet,
	IconDumbbell,
	IconEar,
	IconEye,
	IconEyeOff,
	IconFileCheck,
	IconFileText,
	IconFilter,
	IconFlag,
	IconFolder,
	IconFolderOpen,
	IconGauge,
	IconGift,
	IconGitBranch,
	IconGlobe,
	IconHammer,
	IconHandStop,
	IconHeadphones,
	IconHeart,
	IconHeartRateMonitor,
	IconHistory,
	IconHome,
	IconHospital,
	IconHourglass,
	IconId,
	IconIdBadge,
	IconInbox,
	IconInfoCircle,
	IconKey,
	IconLanguage,
	IconLayoutGrid,
	IconLeaf,
	IconLifebuoy,
	IconList,
	IconLock,
	IconLogin,
	IconLogout,
	IconMail,
	IconMap,
	IconMapPin,
	IconMedal,
	IconMedicineSyrup,
	IconMessageCircle,
	IconMist,
	IconMoon,
	IconNotebook,
	IconPackage,
	IconPaperclip,
	IconPaw,
	IconPencil,
	IconPhone,
	IconPhoto,
	IconPlane,
	IconPlant,
	IconPlus,
	IconPrinter,
	IconPuzzle,
	IconQrcode,
	IconReceipt,
	IconRefresh,
	IconRocket,
	IconRosette,
	IconRoute,
	IconRuler,
	IconScale,
	IconScan,
	IconSchool,
	IconScissors,
	IconScreenShare,
	IconSearch,
	IconSeedling,
	IconSend,
	IconShield,
	IconShieldCheck,
	IconShoppingCart,
	IconSparkles,
	IconSpeakerphone,
	IconStar,
	IconSun,
	IconTable,
	IconTarget,
	IconTent,
	IconThermometer,
	IconTicket,
	IconTimeline,
	IconToolsKitchen,
	IconTrash,
	IconTrendingDown,
	IconTrendingUp,
	IconUmbrella,
	IconUpload,
	IconUser,
	IconUserCheck,
	IconUserPlus,
	IconVaccine,
	IconWallet,
	IconWheelchair,
	IconWorld,
	IconX,
} from '@tabler/icons-react';

export const ICON_MAP: Record<string, TablerIcon> = {
	home: IconHome2,
	dashboard: IconLayoutDashboard,
	statistics: IconChartBar,
	horses: IconHorse,
	'horse-list': IconHorse,
	'horse-details': IconHorse,
	'horse-nfc': IconIdBadge2,
	nfc: IconIdBadge2,
	pedigree: IconListDetails,
	competitions: IconTrophy,
	'available-rooms': IconBed,
	accommodations: IconDoorEnter,
	'stable-list': IconBuildingWarehouse,
	'stable-rooms': IconBed,
	'vet-clinic': IconStethoscope,
	'record-list': IconStethoscope,
	recordlist: IconStethoscope,
	checkup: IconClipboardCheck,
	checkup2: IconClipboardCheck,
	'checkup-types': IconClipboardCheck,
	farrier: IconHorseshoe,
	farrierlist: IconHorseshoe,
	'farrier-list': IconHorseshoe,
	reproduction: IconEgg,
	reproductionpage: IconEgg,
	'semen-inventory': IconFlask,
	science: IconMicroscope,
	medications: IconPill,
	procedures: IconTools,
	'horse-transport-report-page': IconTruck,
	horsetransportreportpage: IconTruck,
	accountant: IconCalculator,
	accountantreview: IconCalculator,
	finance: IconCash,
	financesummary: IconReportMoney,
	'finance-summary': IconReportMoney,
	horsefinancecenter: IconReportMoney,
	pricing: IconTag,
	owners: IconUsers,
	'owner-details': IconUserCircle,
	clients: IconUsers,
	'user-permissions': IconShieldLock,
	userpermissions: IconShieldLock,
	'role-permissions': IconShieldLock,
	'roles-permissions': IconShieldLock,
	'access-control': IconShieldLock,
	settings: IconSettings,
	audit: IconFileCertificate,
	'audit-report': IconFileCertificate,
	backup: IconDatabaseExport,
	alerts: IconApps,
	client_horses: IconHorse,
	client_horse_stats: IconChartBar,
	default: IconBuildingBank,

	// أيقونات عامّة إضافيّة لمنتقي الأيقونة — قابلة للاختيار لأيّ رابط قائمة مخصَّص.
	activity: IconActivity,
	alarm: IconAlarm,
	ambulance: IconAmbulance,
	archive: IconArchive,
	'arrow-down': IconArrowDown,
	'arrow-left': IconArrowLeft,
	'arrow-right': IconArrowRight,
	'arrow-up': IconArrowUp,
	'arrows-exchange': IconArrowsExchange,
	award: IconAward,
	bandage: IconBandage,
	barcode: IconBarcode,
	bath: IconBath,
	battery: IconBattery,
	bed: IconBed,
	'bed-flat': IconBedFlat,
	bell: IconBell,
	'bell-ringing': IconBellRinging,
	bike: IconBike,
	book: IconBook,
	bookmark: IconBookmark,
	box: IconBox,
	brain: IconBrain,
	briefcase: IconBriefcase,
	building: IconBuilding,
	'building-bank': IconBuildingBank,
	'building-warehouse': IconBuildingWarehouse,
	bulb: IconBulb,
	bus: IconBus,
	calendar: IconCalendar,
	'calendar-check': IconCalendarCheck,
	'calendar-clock': IconCalendarClock,
	'calendar-event': IconCalendarEvent,
	camera: IconCamera,
	car: IconCar,
	'car-crash': IconCarCrash,
	cash: IconCash,
	'chart-line': IconChartLine,
	'chart-pie': IconChartPie,
	check: IconCheck,
	checkbox: IconCheckbox,
	'circle-check': IconCircleCheck,
	'circle-x': IconCircleX,
	clipboard: IconClipboard,
	'clipboard-check': IconClipboardCheck,
	'clipboard-list': IconClipboardList,
	clock: IconClock,
	cloud: IconCloud,
	coin: IconCoin,
	'credit-card': IconCreditCard,
	crown: IconCrown,
	database: IconDatabase,
	deer: IconDeer,
	'device-floppy': IconDeviceFloppy,
	diamond: IconDiamond,
	dog: IconDog,
	'door-enter': IconDoorEnter,
	'door-exit': IconDoorExit,
	download: IconDownload,
	droplet: IconDroplet,
	dumbbell: IconDumbbell,
	ear: IconEar,
	egg: IconEgg,
	eye: IconEye,
	'eye-off': IconEyeOff,
	'file-check': IconFileCheck,
	'file-text': IconFileText,
	filter: IconFilter,
	flag: IconFlag,
	flask: IconFlask,
	folder: IconFolder,
	'folder-open': IconFolderOpen,
	gauge: IconGauge,
	gift: IconGift,
	'git-branch': IconGitBranch,
	globe: IconGlobe,
	hammer: IconHammer,
	'hand-stop': IconHandStop,
	headphones: IconHeadphones,
	heart: IconHeart,
	'heart-rate-monitor': IconHeartRateMonitor,
	history: IconHistory,
	house: IconHome,
	hospital: IconHospital,
	hourglass: IconHourglass,
	id: IconId,
	'id-badge': IconIdBadge,
	inbox: IconInbox,
	'info-circle': IconInfoCircle,
	key: IconKey,
	language: IconLanguage,
	'layout-grid': IconLayoutGrid,
	leaf: IconLeaf,
	lifebuoy: IconLifebuoy,
	list: IconList,
	lock: IconLock,
	login: IconLogin,
	logout: IconLogout,
	mail: IconMail,
	map: IconMap,
	'map-pin': IconMapPin,
	medal: IconMedal,
	'medicine-syrup': IconMedicineSyrup,
	'message-circle': IconMessageCircle,
	mist: IconMist,
	moon: IconMoon,
	notebook: IconNotebook,
	package: IconPackage,
	paperclip: IconPaperclip,
	paw: IconPaw,
	pencil: IconPencil,
	phone: IconPhone,
	photo: IconPhoto,
	pill: IconPill,
	plane: IconPlane,
	plant: IconPlant,
	plus: IconPlus,
	printer: IconPrinter,
	puzzle: IconPuzzle,
	'qr-code': IconQrcode,
	receipt: IconReceipt,
	refresh: IconRefresh,
	rocket: IconRocket,
	rosette: IconRosette,
	route: IconRoute,
	ruler: IconRuler,
	scale: IconScale,
	scan: IconScan,
	school: IconSchool,
	scissors: IconScissors,
	'screen-share': IconScreenShare,
	search: IconSearch,
	seedling: IconSeedling,
	send: IconSend,
	shield: IconShield,
	'shield-check': IconShieldCheck,
	'shopping-cart': IconShoppingCart,
	sparkles: IconSparkles,
	speakerphone: IconSpeakerphone,
	star: IconStar,
	sun: IconSun,
	table: IconTable,
	target: IconTarget,
	tent: IconTent,
	thermometer: IconThermometer,
	ticket: IconTicket,
	timeline: IconTimeline,
	'tools-kitchen': IconToolsKitchen,
	trash: IconTrash,
	'trending-down': IconTrendingDown,
	'trending-up': IconTrendingUp,
	trophy: IconTrophy,
	truck: IconTruck,
	umbrella: IconUmbrella,
	upload: IconUpload,
	user: IconUser,
	'user-check': IconUserCheck,
	'user-plus': IconUserPlus,
	vaccine: IconVaccine,
	wallet: IconWallet,
	wheelchair: IconWheelchair,
	world: IconWorld,
	x: IconX,
};

export function getMenuIcon(item: { icon_key?: string; permission_key?: string; text_key?: string }): TablerIcon {
	const key = String(item?.icon_key || item?.permission_key || item?.text_key || '').toLowerCase();
	return ICON_MAP[key] || ICON_MAP.default;
}
